import AsyncStorage, { Key } from '../../../utils/asyncStorage';

import { useEffect } from 'react';
import useBehaviorSubject from '../../../functions/hooks/useBehaviorSubject';
import { usePersistFn } from '../../../functions/hooks/usePersistFn';
import { useServiceFactory } from '../../../functions/services';
import { RichFeaturedTagItem } from '../../../generated/api';

export const useFeaturedTags = () => {
  const { searchService } = useServiceFactory();

  // top category items are intended to be cached locally
  const featuredTags$ = AsyncStorage.behaviorSubject$<RichFeaturedTagItem[]>(
    Key.ShopFeaturedTags,
  );

  const [featuredTags, setFeaturedTags] = useBehaviorSubject(featuredTags$);

  const onLoad = usePersistFn(async () => {
    const res = await searchService.searchApiControllerSearchFeaturedTags({
      pageNo: 1,
      pageSize: 100,
    });
    setFeaturedTags(res.data.rows);
  });

  useEffect(() => {
    void onLoad();
  }, [onLoad]);

  return featuredTags ?? [];
};
